// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"TitleDescription_itemTitle__Iujx1","itemDescription":"TitleDescription_itemDescription__3669s"};